import { useState } from 'react'
import { useEnablePsychiatry } from './useEnablePsychiatry'

interface usePatientSpecialitiesType {
  specialities: Array<{
    name: string,
    role: string
    code: string,
    profileCode: string
  }>
  hasMoreSpecialties: boolean
  updatePlanGroupCode: (planGroupCode: string) => void
}

export const usePatientSpecialities = (): usePatientSpecialitiesType => {

  const [planGroupCode, setPlanGroupCode] = useState('')
  
  const showPsychiatry = useEnablePsychiatry()

  const patientSpecialities = [
    {
      name: 'Psicologia',
      role: 'psicólogo',
      code: 'PSIC',
      profileCode: 'TVTVPSIC'
    },
    showPsychiatry && {
      name: 'Psiquiatria',
      role: 'psiquiatra',
      code: 'PSIQ',
      profileCode: 'TVTVPSIQ'
    }
  ].filter(speciality => typeof speciality !== 'boolean')

  return {
    specialities: patientSpecialities,
    hasMoreSpecialties: patientSpecialities.length > 1,
    updatePlanGroupCode: (planGroupCode) => setPlanGroupCode(planGroupCode)
  }
}